function isGeolocationSupported(): boolean {
  return typeof navigator !== 'undefined' && !!navigator.geolocation;
}

export const locationService = {
  isSupported: isGeolocationSupported,

  getCurrentLocation(
    options: PositionOptions = {},
    onError?: (error: GeolocationPositionError) => void
  ): Promise<{ latitude: number; longitude: number } | null> {
    return new Promise(resolve => {
      if (!isGeolocationSupported()) {
        resolve(null);
        return;
      }

      navigator.geolocation.getCurrentPosition(
        position =>
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          }),
        error => {
          onError?.(error);
          resolve(null);
        },
        {
          enableHighAccuracy: false,
          timeout: 10000,
          maximumAge: 600000,
          ...options,
        }
      );
    });
  },
};
